import _ from "lodash";
import moment from "moment";
import React from "react";
import submit from "submit-form";
import cx from "classnames";
import { withTranslation } from "react-i18next";
import i18n from "../../../i18n";
import EditSetsModal from "../../../parts/modals/edit-set";
import AddSecondaryMovementModal from "../../../parts/modals/add-secondary-movement";
import UpdateRepMaximumModal from "../../../parts/modals/update-rep-maximum";
import fromIntensity from "../../../utils/get-zone";

const {
  WEIGHT_UNITS,
  PRIMARIES,
  DATE_FORMATS: { DATE_DAY_FORMAT },
} = require("../../../constants");

class View extends React.Component {
  initDND() {
    const dragula = require("react-dragula");
    const { editExercise } = this.context.locals;
    let from = null;
    this.sets = dragula([this.refs.sets], {
      invalid: (el, handle) =>
        !_.includes(handle.getAttribute("class"), "sort-handle"),
    });
    this.sets.on("drag", handleDrag);
    this.sets.on("drop", handleDrop);

    function handleDrag(el, source) {
      from = Array.from(source.childNodes).indexOf(el) - 1;
    }
    function handleDrop(el) {
      const to = Array.from(el.parentNode.childNodes).indexOf(el) - 1;
      if (from !== to && to >= 0) {
        submit(`/actions/exercise/sets/move/${from}/${to}/${editExercise._id}`);
      }
    }
  }
  stopDND() {
    this.sets && this.sets.destroy();
  }

  componentDidMount() {
    this.initDND();
  }
  componentDidUpdate() {
    this.stopDND();
    this.initDND();
  }
  componentWillUnmount() {
    this.stopDND();
  }

  render() {
    const { t } = this.props;
    const { locals } = this.context;
    const { editExercise, activeUser, query } = locals;
    const { primary = "squat", type } = query;

    const exerciseTypes = ["primary", "secondary", "assistant"];
    const isAssistant = editExercise.type === "assistant";
    const defaultPrimary = _.get(editExercise, "primary", "squat");

    const activeDate = moment(_.get(editExercise, "date", query.day));
    const activeId = _.get(editExercise, "_id", "");

    const secondaries = (
      _.get(
        activeUser,
        `exerciseLibrary.${isAssistant ? "assistant" : primary}`
      ) || []
    ).sort();
    const isNew = !activeId;
    const defaultSecondary =
      !isNew && !_.get(query, "movement", false)
        ? _.get(editExercise, "secondary")
        : _.get(query, "movement");

    const defaultRepMax = locals.fromMetric(
      _.get(
        editExercise,
        `repMaximums.${primary}`,
        _.get(activeUser, `repMaximums.${primary}`, 0)
      )
    );

    const exerciseType = !_.isEmpty(type)
      ? type
      : _.get(editExercise, "type", "primary");
    return (
      <form
        action={`/actions/exercise/save/${activeId}`}
        className="Edit-Exercise"
        method="POST"
        data-noreset
      >
        <input type="hidden" name="primary" value={primary} />
        <input type="hidden" name="type" value={exerciseType} />
        <input type="hidden" name="date" value={activeDate.toJSON()} />

        <div className="Main">
          <div className="frame">
            <div className="columns">
              <div className="column" data-col="1/1">
                <div className="label">{t("editExercise.exerciseType")}</div>
                {_.map(exerciseTypes, (type) => {
                  const checked = type === exerciseType;
                  return (
                    <a
                      key={type}
                      className={cx("radio-input", { checked })}
                      href={`/actions/refresh?type=${type}`}
                    >
                      <span className="radio" />
                      <span className={`text ${type}`}>
                        {_.capitalize(type)}
                      </span>
                    </a>
                  );
                })}
              </div>

              <hr />

              <div className="column" data-col="1/1">
                <div className="label">{t("editExercise.movement")}</div>
                <div className="Secondary-Selector">
                  {exerciseType != "assistant" &&
                    _.map(PRIMARIES, (type) => {
                      const checked = type === primary;
                      return (
                        <a
                          key={type}
                          className={cx("radio-input", { checked })}
                          href={`/actions/refresh?primary=${type}`}
                        >
                          <span className="radio" />
                          <span className={`text ${type}`}>
                            {_.capitalize(type)}
                          </span>
                        </a>
                      );
                    })}

                  {exerciseType != "primary" && (
                    <div className="selector">
                      <select
                        name="secondary"
                        className="select-input"
                        key={defaultSecondary}
                        defaultValue={defaultSecondary}
                      >
                        <option value="">
                          {isAssistant
                            ? t("editExercise.selectMovement")
                            : t("editExercise.selectSecondary")}
                        </option>
                        {_.map(secondaries, (secondary) => {
                          return (
                            <option key={secondary} value={secondary}>
                              {secondary}
                            </option>
                          );
                        })}
                      </select>

                      <div className="actions">
                        <a
                          href="/dashboard/settings/exercise-library"
                          className="manage"
                        >
                          {t("editExercise.manageExerciseLibrary")}
                        </a>
                        <a
                          className="add-new"
                          href={
                            `/actions/refresh?modal[type]=add-secondary-movement&modal[primary]=` +
                            (isAssistant
                              ? "assistant&primary=assistant"
                              : primary)
                          }
                        >
                          {t("editExercise.addNew")}
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <hr />

              {exerciseType !== "assistant" && (
                <div className="column" data-col="1/2">
                  <div className="label">{t("editExercise.repMaximumRm")}</div>
                  <div className="temp-faux-input">
                    <div>{locals.withWeight(defaultRepMax)}</div>
                    <a href="/actions/refresh?modal[type]=update-rep-maximum" />
                  </div>
                </div>
              )}

              <div className="column" data-col="1/1">
                <div className="Edit-Routines">
                  <a
                    className="add"
                    href="/actions/refresh?modal[type]=edit-set"
                  >
                    {t("editExercise.addSets")}
                  </a>

                  <div ref="sets">
                    <div className="labels">
                      <div className="sets">{t("editExercise.sets")}</div>
                      <div className="reps">{t("editExercise.reps")}</div>
                      <div className="load">{t("editExercise.load")}</div>
                      <div className="intensity">{t("editExercise.intensity")}</div>
                      <div className="rpe">{t("editExercise.rpe")}</div>
                      <div className="zone">{t("editExercise.zone")}</div>
                    </div>
                    {_.map(_.get(editExercise, "sets"), (it, i) => {
                      const equippedRepMax = locals.fromMetric(
                        it.equippedRepMax
                      );
                      const repMax = _.get(it, "equipped", false)
                        ? equippedRepMax
                        : defaultRepMax;
                      const load = locals.fromMetric(it.load);
                      const percentRM = _.round((load / repMax) * 100, 1);
                      const isEquipped = !isAssistant && it.equipped;
                      const hasLoad = Boolean(load);
                      return (
                        <div key={_.uniqueId()} className="Edit-Routine">
                          <div className="actions">
                            <div className="sort-handle">
                              <img
                                className="sort-handle"
                                src="/img/svg/icon_drag.svg"
                                alt="sort handle"
                              />
                            </div>

                            <a
                              className="edit"
                              href={`/actions/refresh?modal[type]=edit-set&modal[index]=${i}`}
                            >
                              <img src="/img/svg/icon_edit.svg" alt={t("common:edit")} />
                            </a>

                            <a
                              className="remove"
                              href={`/actions/exercise/sets/remove/${i}/${editExercise._id}`}
                            >
                              <img
                                src="/img/svg/icon_remove.svg"
                                alt={t("common:remove")}
                              />
                            </a>
                          </div>
                          <div className="details">
                            <div className="sets">
                              {it.sets}
                              &nbsp;
                            </div>
                            <div className="reps">
                              {it.reps}
                              &nbsp;
                            </div>
                            <div className="load">
                              {hasLoad && locals.withWeight(load)}
                              &nbsp;
                            </div>
                            <div className="intensity">
                              {hasLoad && !isAssistant && percentRM + "%"}
                              &nbsp;
                            </div>
                            <div className="rpe">
                              {it.rpe > 0 && it.rpe}
                              &nbsp;
                            </div>
                            <div className="zone">
                              <span
                                className={`zone-dot ${fromIntensity(
                                  percentRM,
                                  it.reps
                                )}`}
                              />
                              &nbsp;
                            </div>
                            {isEquipped && (
                              <div className="equipped">
                                <span>
                                  <b>{t("editExercise.equipped")}</b> {it.equipment}
                                </span>
                                <span>
                                  <b>&nbsp; {t("editExercise.rm")}</b>
                                  &nbsp;
                                  {locals.withWeight(equippedRepMax)}
                                </span>
                              </div>
                            )}
                          </div>

                          {!isAssistant && (
                            <input
                              type="hidden"
                              name={`sets[${i}][equipped]`}
                              value={it.equipped}
                            />
                          )}
                          {!isAssistant && (
                            <input
                              type="hidden"
                              name={`sets[${i}][equipment]`}
                              value={it.equipment}
                            />
                          )}
                          {!isAssistant && (
                            <input
                              type="hidden"
                              name={`sets[${i}][equippedRepMax]`}
                              value={it.equippedRepMax}
                            />
                          )}
                          <input
                            type="hidden"
                            name={`sets[${i}][rpe]`}
                            value={it.rpe}
                          />
                          <input
                            type="hidden"
                            name={`sets[${i}][reps]`}
                            value={it.reps}
                          />
                          <input
                            type="hidden"
                            name={`sets[${i}][sets]`}
                            value={it.sets}
                          />
                          <input
                            type="hidden"
                            name={`sets[${i}][load]`}
                            value={it.load}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="column" data-col="1/1">
                <div className="label">{t("common:notes")}</div>
                <textarea
                  className="textarea-input"
                  name="notes"
                  defaultValue={_.get(editExercise, "notes")}
                />
              </div>
            </div>
          </div>

          <div className="actions">
            {isNew && (
              <button
                type="submit"
                className="button button-input"
                value="true"
                name="addAnother"
              >
                {t("editExercise.saveAndAddAnother")}
              </button>
            )}
            <button type="submit" className="button button-input">
              {isNew ? t("common:save") : t("editExercise.saveExercise")}
            </button>

            {!isNew ? (
              <a
                className="button delete"
                href={`/actions/exercise/remove/${_.get(editExercise, "_id")}`}
              >
                {t("editExercise.deleteExercise")}
              </a>
            ) : (
              <a
                className="button alt"
                href={`/actions/exercise/cancel/?redirect=${encodeURIComponent(
                  `/dashboard/program-builder/?day=${activeDate.format(
                    DATE_DAY_FORMAT
                  )}`
                )}`}
              >
                {t("common:cancel")}
              </a>
            )}
          </div>
        </div>
      </form>
    );
  }
}

const EditExercise = (app) => {
  app.get(
    "/edit-exercise/:exercise?",
    async ({ req, res, locals, load }, next) => {
      const { params, query } = req;
      await load("editExercise", { exercise: params.exercise });

      const modal = _.get(query, "modal", {});
      locals.modal = {
        "edit-set": <EditSetsModal />,
        "add-secondary-movement": <AddSecondaryMovementModal />,
        "update-rep-maximum": <UpdateRepMaximumModal />,
      }[modal.type];
      locals.heading = params.exercise
        ? [i18n.t("dashboard:editExercise.editExerciseHeading")]
        : [i18n.t("dashboard:editExercise.addAnExerciseHeading")];

      // Update primary when query changes (defaults to set primary).
      const { editExercise } = locals;

      query.primary = editExercise.primary =
        query.primary || editExercise.primary;

      query.type = editExercise.type = query.type || editExercise.type;

      res.body = <ViewWithI18n />;
    }
  );
};

const ViewWithI18n = withTranslation("dashboard")(View);

export default EditExercise;
